import { useMemo } from 'react';

import { AnswerReveal, StandardPatternBody } from '@quizzach/components';
import { IQuestion } from '@quizzach/interfaces';
import { analyzeEstimationQuestion, patternAnswerHtml } from '@quizzach/utils';
import { QuestionText, QuestionContainer } from '@quizzach/play-styles';

interface IEstimationQuestionProps {
	color: string;
	currentQuestion: IQuestion;
}

interface IEstimationQuestionAnswerProps {
	questionContainerColor: string;
	answerContainerColor: string;
	currentQuestion: IQuestion;
}

export const EstimationQuestionDesktop = (props: IEstimationQuestionProps) => {
	const { color, currentQuestion } = props;
	const analysis = useMemo(
		() => analyzeEstimationQuestion(currentQuestion),
		[currentQuestion]
	);

	return analysis.pattern || analysis.note || analysis.kicker ? (
		<StandardPatternBody analysis={analysis} color={color} />
	) : (
		<QuestionContainer color={color}>
			<QuestionText>
				<div dangerouslySetInnerHTML={{ __html: analysis.questionHtml }} />
			</QuestionText>
		</QuestionContainer>
	);
};

export const EstimationQuestionAnswerDesktop = (
	props: IEstimationQuestionAnswerProps
) => {
	const { questionContainerColor, currentQuestion } = props;
	const analysis = useMemo(
		() => analyzeEstimationQuestion(currentQuestion),
		[currentQuestion]
	);

	return (
		<>
			{analysis.pattern || analysis.note || analysis.kicker ? (
				<StandardPatternBody
					analysis={analysis}
					color={questionContainerColor}
					dim
				/>
			) : (
				<QuestionContainer color={questionContainerColor}>
					<QuestionText $small style={{ margin: '20px 0px 0px' }}>
						<div dangerouslySetInnerHTML={{ __html: analysis.questionHtml }} />
					</QuestionText>
				</QuestionContainer>
			)}
			<AnswerReveal
				revealKey={currentQuestion.uuid}
				answerHtml={patternAnswerHtml(
					analysis.pattern,
					currentQuestion.estimation_question?.answer || ''
				)}
				explanation={currentQuestion.estimation_question?.explanation}
			/>
		</>
	);
};
